import React from "react";

import { KeyTermsPage } from "@harrow-education/ui-components";

const KeyTerms = (props) => {
  return <KeyTermsPage {...props} />;
};

export default KeyTerms;
